import React from "react";
import { motion } from "framer-motion";
import { GALLERY } from "../lib/venue";

// Bento layout (5 images on a 4-col grid)
const layout = [
  "md:col-span-2 md:row-span-2 aspect-square md:aspect-auto",
  "aspect-square",
  "aspect-square",
  "aspect-square",
  "aspect-square",
];

export const Gallery = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 sm:py-32 px-6 sm:px-10 bg-[#0A0A0A] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-[#F5A623] font-semibold">
              / The Scene
            </span>
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl text-[#FDFBF7] uppercase mt-4 leading-[0.9]">
              A night
              <br />
              <span className="text-[#F5A623]">in pictures.</span>
            </h2>
          </div>
          <p className="max-w-md text-[#FDFBF7]/65 text-base leading-relaxed">
            Bands, crowds, cold pints. The good stuff captured on the way out
            the door.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
          {GALLERY.map((img, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              data-testid={`gallery-item-${i}`}
              className={`relative overflow-hidden group ${layout[i]} bg-[#111114] border border-white/10`}
            >
              <img
                src={img.url}
                alt={img.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
